// extracted by mini-css-extract-plugin
module.exports = {"root":"TableHeading_root__31CdY","clinicsSelect":"TableHeading_clinicsSelect__lXm4B"};